(function () {
  const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (Number(cents || 0) / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(value))))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  function setMenu(open) {
    document.body.classList.toggle('menu-open', open);
    document.querySelectorAll('[data-menu-open]').forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
    document.querySelectorAll('[data-mobile-drawer]').forEach((drawer) => drawer.setAttribute('aria-hidden', String(!open)));
  }

  function setPanel(panel, open) {
    if (!panel) return;
    panel.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('drawer-open', open);
  }

  function initHeader(root) {
    const header = root.querySelector('[data-header]') || document.querySelector('[data-header]');
    if (!header || header.dataset.boundScroll) return;
    header.dataset.boundScroll = 'true';
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 14);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-accordion-trigger]').forEach((trigger) => {
      if (trigger.dataset.boundAccordion) return;
      trigger.dataset.boundAccordion = 'true';
      trigger.addEventListener('click', () => {
        const item = trigger.closest('[data-accordion-item]');
        const open = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function initQuantity(root) {
    root.querySelectorAll('[data-quantity]').forEach((quantity) => {
      if (quantity.dataset.boundQuantity) return;
      quantity.dataset.boundQuantity = 'true';
      const input = quantity.querySelector('input');
      quantity.querySelectorAll('button').forEach((button) => {
        button.addEventListener('click', () => {
          const direction = button.dataset.qty === 'plus' ? 1 : -1;
          const current = Number(input.value || 1);
          const minimum = Number(input.getAttribute('min') || 1);
          input.value = Math.max(minimum, current + direction);
        });
      });
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-gallery]').forEach((gallery) => {
      if (gallery.dataset.boundGallery) return;
      gallery.dataset.boundGallery = 'true';
      const mainImage = gallery.querySelector('[data-gallery-main]');
      const zoomLink = gallery.querySelector('[data-gallery-zoom]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const nextSrc = thumb.getAttribute('data-src');
          const nextZoom = thumb.getAttribute('data-zoom') || nextSrc;
          const nextAlt = thumb.getAttribute('data-alt') || '';
          if (!nextSrc || !mainImage) return;
          mainImage.src = nextSrc;
          mainImage.alt = nextAlt;
          if (zoomLink && nextZoom) zoomLink.href = nextZoom;
          thumbs.forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initProductForms(root) {
    root.querySelectorAll('[data-product-root]').forEach((productRoot) => {
      if (productRoot.dataset.boundProduct) return;
      productRoot.dataset.boundProduct = 'true';
      const json = productRoot.querySelector('[data-product-json]');
      const variants = json ? JSON.parse(json.textContent || '[]') : [];
      const idInput = productRoot.querySelector('[data-variant-id]');
      const price = productRoot.querySelector('[data-price]');
      const sku = productRoot.querySelector('[data-sku]');
      const inventory = productRoot.querySelector('[data-inventory]');
      const addButton = productRoot.querySelector('[data-add-to-cart]');
      const addButtonText = productRoot.querySelector('[data-add-to-cart-text]');

      function selectedOptions() {
        return Array.from(productRoot.querySelectorAll('[data-option-position]')).map((fieldset) => {
          const checked = fieldset.querySelector('[data-product-option]:checked');
          return checked ? checked.value : null;
        });
      }

      function findVariant() {
        const options = selectedOptions();
        return variants.find((variant) => variant.options.every((option, index) => option === options[index]));
      }

      function renderVariant() {
        const variant = findVariant() || variants[0];
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (price) {
          const compare = variant.compare_at_price && variant.compare_at_price > variant.price
            ? ` <s class="price__compare">${formatMoney(variant.compare_at_price)}</s>`
            : '';
          price.innerHTML = `<span class="price__regular">${formatMoney(variant.price)}</span>${compare}`;
        }
        if (sku) {
          sku.hidden = !variant.sku;
          sku.textContent = variant.sku ? `SKU: ${variant.sku}` : '';
        }
        if (inventory) inventory.textContent = variant.available ? 'In stock' : 'Out of stock';
        if (addButton) {
          addButton.disabled = !variant.available;
          if (addButtonText) addButtonText.textContent = variant.available ? 'Add To Cart' : 'Sold Out';
        }
      }

      productRoot.querySelectorAll('[data-product-option]').forEach((input) => {
        input.addEventListener('change', renderVariant);
      });
      renderVariant();
    });
  }

  function initPredictiveSearch(root) {
    const input = root.querySelector('[data-predictive-search-input]');
    const results = root.querySelector('[data-predictive-search-results]');
    if (!input || !results || input.dataset.boundSearch) return;
    input.dataset.boundSearch = 'true';
    let controller;

    input.addEventListener('input', async () => {
      const query = input.value.trim();
      results.innerHTML = '';
      if (query.length < 2) return;
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const response = await fetch(`${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=4&section_id=predictive-search`, {
          signal: controller.signal
        });
        if (!response.ok) return;
        results.innerHTML = await response.text();
      } catch (error) {
        if (error.name !== 'AbortError') console.warn(error);
      }
    });
  }

  function init(root) {
    initHeader(root);
    initAccordions(root);
    initQuantity(root);
    initGallery(root);
    initProductForms(root);
    initPredictiveSearch(root);
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-menu-open]')) setMenu(true);
    if (event.target.closest('[data-menu-close]') || event.target.closest('[data-menu-scrim]')) setMenu(false);
    if (event.target.closest('[data-search-open]')) {
      event.preventDefault();
      setPanel(document.querySelector('[data-search-drawer]'), true);
    }
    if (event.target.closest('[data-search-close]')) setPanel(document.querySelector('[data-search-drawer]'), false);
    if (event.target.closest('[data-cart-close]')) setPanel(document.querySelector('[data-cart-drawer]'), false);
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-drawer-trigger]');
    if (!trigger) return;
    const group = trigger.closest('[data-drawer-group]');
    const open = group.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', String(open));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMenu(false);
      setPanel(document.querySelector('[data-search-drawer]'), false);
      setPanel(document.querySelector('[data-cart-drawer]'), false);
    }
  });

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
